<template lang="pug">
i(
  v-if="message.length > 0"
  v-tooltip="tooltipOptions"
  :class="classes"
  :title="message"
  :data-original-title="message"
  :data-html="dataHtml"
)
</template>

<script>
export default {
  name: 'AppTooltipIcon',
  props: {
    message: {
      type: String,
      required: true,
    },
    placement: {
      type: String,
      default: 'auto bottom',
    },
    type: {
      type: String,
      default: 'info',
    },
    textType: {
      type: String,
      default: 'muted',
    },
    dataHtml: {
      type: Boolean,
      default: false,
    },
    size: {
      type: Number,
      default: 16,
    },
  },
  computed: {
    classes() {
      const classes = ['hi', `hi-${this.size}`, `hi-${this.type}`];

      if (this.textType) {
        classes.push(`text-${this.textType}`);
      }

      return classes;
    },
    tooltipOptions() {
      return {
        placement: this.placement,
      };
    },
  },
};
</script>
